// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__KGu3x","error":"Textarea_error__3JOxN","readonly":"Textarea_readonly__368HZ","disabled":"Textarea_disabled__IRxIC"};